import { useCallback, useEffect, useRef, useState } from 'react';

import sectorEndpoint from '../../../../api/services/sectorEndpoint';

export const useFetchDepartmentEmployees = (departmentIdList = []) => {
  const [loading, setLoading] = useState(true);
  const [employees, setEmployees] = useState([]);
  const isMounted = useRef(true);

  const fetchAllEmployees = useCallback(async () => {
    setLoading(true);
    try {
      const response = await sectorEndpoint.fetchEmployeeBySectorsId(departmentIdList);
      if (response.status === 200) {
        if (isMounted.current) setEmployees(response.data);
      }
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line
  }, [departmentIdList]);

  useEffect(() => {
    isMounted.current = true;
    fetchAllEmployees().catch(console.error);
    return () => {
      isMounted.current = false;
    };
  }, [fetchAllEmployees, departmentIdList]);

  return {
    loading,
    employees,
  };
};
